import { render, staticRenderFns } from "./Znt-ctr.vue?vue&type=template&id=2a8fe348&scoped=true"
import script from "./Znt-ctr.vue?vue&type=script&lang=js"
export * from "./Znt-ctr.vue?vue&type=script&lang=js"
import style0 from "./Znt-ctr.vue?vue&type=style&index=0&id=2a8fe348&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8fe348",
  null
  
)

export default component.exports